// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"Loading_loading_container__xphjZ","loading_spinner_img":"Loading_loading_spinner_img__SjOpy","spin":"Loading_spin__TS_vb"};